import Vue from "vue";
import moment from "moment";
import { googleApiKeys } from "../package.json";
import UploadService from "./services/uploadService";
import UseLang from "./services/Language";
import { reduceFileSize, blobToFile } from "./services/Imagecompressions";

const Compress = require("compress.js");
const uuidv4 = require("uuid/v4");

const globals = new Vue({
  name: "globals",
  computed: {
    currentUserRole() {
      if (this.currentUserInfo && this.currentUserInfo.UserTypeId)
        return this.currentUserInfo.UserTypeId;
      return -1;
    },
    currentDateFormatForInputMask() {
      let dateFormat = "yyyy-mm-dd";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "dd.mm.yyyy";
          break;
        case "fr":
        case "es":
          dateFormat = "dd/mm/yyyy";
          break;
        default:
          dateFormat = "yyyy-mm-dd";
      }
      return dateFormat;
    },
    currentDateFormatForMoment() {
      let dateFormat = "YYYY-MM-DD";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "DD.MM.YYYY";
          break;
        case "fr":
        case "es":
          dateFormat = "DD/MM/YYYY";
          break;
        default:
          dateFormat = "YYYY-MM-DD";
      }
      return dateFormat;
    },
    currentDateTimeFormatForMoment() {
      return this.currentDateFormatForMoment + " - HH:mm:ss";
    },
    isMobileBrowser() {
      // Recommended by MDN: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
      if (navigator.userAgent.indexOf("Mobi") > -1) return true;
      return false;
    },
    isChromeBrowser() {
      return !!window.chrome;
    },
    isSafariBrowser() {
      return navigator.vendor && navigator.vendor.indexOf("Apple") > -1;
    },
    isIEBrowser() {
      var ua = window.navigator.userAgent;
      // IE 10 or older
      if (ua.indexOf("MSIE ") > 0) return true;
      // IE 11
      if (ua.indexOf("Trident/") > 0) return true;
      // Edge (IE 12+)
      if (ua.indexOf("Edge/") > 0) return true;
      // other browser
      return false;
    },
    currentLocale() {
      return this.selectedLanguage.substring(0, 2);
    },
    googleApiKey() {
      if (_.includes(process.auth.redirectUrl, "msmloop.com"))
        return googleApiKeys.msm;
      if (_.includes(process.auth.redirectUrl, "audi-mysteryshopping"))
        return googleApiKeys.audi;
      return googleApiKeys.dev;
    },
  },
  methods: {
    /**
     * Sets the language and datetime formate to the locale "loc"
     * Defaults to this.currentLocale
     * @param {string} [loc] - the target locale
     */
    localizeFlatpickrConfig(loc = this.currentLocale) {
      this.flatpickrDateConfig.locale = loc;
      this.flatpickrIsoDateConfig.locale = loc;
      this.flatpickrDatetimeConfig.locale = loc;

      let dateFormat;
      switch (loc) {
        case "de":
          dateFormat = "d.m.Y";
          break;
        case "fr":
        case "es":
          dateFormat = "d/m/Y";
          break;
        default:
          dateFormat = "Y-m-d";
      }
      this.flatpickrDateConfig.altFormat = dateFormat;
      this.flatpickrIsoDateConfig.altFormat = dateFormat;
      this.flatpickrDatetimeConfig.altFormat = dateFormat + " H:i";
    },
    /**
     * We used to manually toogle open(),but this broke support for mobile and is disabled at the moment
     * @param {String} inputId the Id of the input element
     */
    toggleFlatpickr(inputId) {
      return;
      let el = document.getElementById(inputId);
      if (!el) return;
      let fp = el._flatpickr;
      if (!fp) return;
      fp.toggle();
    },
    showSpinner(immediate) {
      if (!this.$debouncedShowSpinnerFunc)
        this.$debouncedShowSpinnerFunc = _.debounce(
          () => (this.spinnerVisible = true),
          500
        );

      if (!this.$stackedSpinnerRequests) this.$stackedSpinnerRequests = 0;
      this.$stackedSpinnerRequests++;

      this.$debouncedShowSpinnerFunc();
      if (immediate) this.$debouncedShowSpinnerFunc.flush();
    },
    hideSpinner(clear = false) {
      if (--this.$stackedSpinnerRequests > 0 && !clear) return;

      this.$stackedSpinnerRequests = 0; // Avoid negative values
      if(this.$debouncedShowSpinnerFunc){
        this.$debouncedShowSpinnerFunc.cancel();
      }
      this.spinnerVisible = false;
    },
    getCurrencyString(value, currencyCode) {
      if (typeof value === "undefined" || isNaN(value) || value === null)
        return "";
      let result = value.toFixed(2);
      let currency;
      switch (currencyCode) {
        case "EUR":
          currency = {
            symbol: "€",
            prefix: false,
          };
          break;
        case "USD":
          currency = {
            symbol: "$",
            prefix: true,
          };
          break;
        case "CNY":
          currency = {
            symbol: "¥",
            prefix: false,
          };
          break;
        default:
          currency = {
            symbol: "",
            prefix: false,
          };
      }

      switch (this.currentLocale) {
        case "de":
          result = result
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          break;
        default:
          result = result
            .replace(",", ".")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      result = currency.prefix
        ? `${currency.symbol} ${result}`
        : `${result} ${currency.symbol}`;
      return result;
    },
    showSuccessSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00023;
      options.style = "snackbar-success";
      options.id = "successSnackbar";
      options.onClose = () => {
        $("#successSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#successSnackbar > span").show();
    },
    showDebugErrorSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      options.timeout += 5000;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar2";
      options.onClose = () => {
        $("#errorSnackbar2 > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar2 > span").show();
    },
    showErrorSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      options.timeout += 5000;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar";
      options.onClose = () => {
        $("#errorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar > span").show();
    },
    showDebugErrorSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      options.timeout += 5000;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      if (typeof text === "object") {
        options.content = this.lang.G00024;
      }
      options.style = "snackbar-error";
      options.id = "debugerrorSnackbar";
      options.onClose = () => {
        $("#DebugerrorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#DebugerrorSnackbar > span").show();
    },
    showWarningSnackbar(text, timeout, hide = false) {
      let options = _.cloneDeep(this.snackbarConfig);
      options.timeout = 0;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      if (typeof text === "object") {
        options.content = this.lang.G00024;
      }
      options.style = "snackbar-warning";
      options.id = "warningSnackbar";
      options.onClose = () => {
        $("#warningSnackbar > span").hide();
      };
      $.snackbar(options);
      if (hide) {
        $("#warningSnackbar").hide();
      } else {
        $("#warningSnackbar").show();
      }
    },
    /**
     * Downloads a file
     * @param {String} guid The download guid
     */
    async downloadFile(guid) {
      const fileBlob = await UploadService.getFileById(guid);
      const docUrl = document.createElement("a");
      docUrl.href = window.URL.createObjectURL(fileBlob);
      docUrl.setAttribute("download", fileBlob.name);
      document.body.appendChild(docUrl);
      docUrl.click();
      docUrl.remove();
    },
    /**
     * Downloads a file and names it
     * @param {String} guid The download guid
     * @param {String} filename The file name
     */
    async downloadFilewithName(guid, filename) {
      const FILE = await UploadService.getFileURLById(guid);
      const docUrl = document.createElement("a");
      docUrl.href = FILE;
      docUrl.setAttribute("download", filename);
      document.body.appendChild(docUrl);
      docUrl.click();
      docUrl.remove();
    },

    /**
     * Compress file using https://www.npmjs.com/package/compress.js
     * File type does not get changed, but file get resized
     * @param {Blob} file
     * @param {number} size the max size in MB
     */
    compressFile(file, size) {
      return new Promise((resolve, reject) => {
        const compress = new Compress();
        compress
          .compress([file], {
            size: size,
            quality: 0.9,
            maxWidth: 1920,
            maxHeight: 1920,
            resize: true, // default
          })
          .then((results) => {
            const img1 = results[0];
            const base64str = img1.data;
            const imgExt = img1.ext;
            const compressedFile = Compress.convertBase64ToFile(
              base64str,
              imgExt
            );
            compressedFile.name = file.name;
            compressedFile.lastModifiedDate = new Date();
            resolve(new File([compressedFile], file.name));
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Upload file
     * @param {Blob} file
     * @param {boolean} compress on default no compression
     * @param {callback} success
     * @param {callback} error
     * @param {callback} done
     */
    async uploadFile(file, compress = false, success, error, done) {
      if (compress) {
        file = await this.compressFile(file, 1).catch((err) => {
          console.error("Error while compressing");
          console.error(err);
          this.$emit("openGlobalErrorDialog", {errorText: this.lang.G00033, colorOrange: false});
        });
      }
      let uploadData = new FormData();
      uploadData.append("file", file, file.name);
      let uploadGuid = uuidv4();
      this.pendingUploads[uploadGuid] = {};
      this.pendingUploads[uploadGuid].request = $.ajax({
        method: "POST",
        url: "api/Upload",
        data: uploadData,
        dataType: "json",
        contentType: false,
        processData: false,
        global: false,
        xhr: () => {
          let xhr = $.xhr();
          if (xhr.upload) {
            this.pendingUploads[uploadGuid].sizes = [0, file.size, 0];

            xhr.upload.addEventListener(
              "progress",
              (e) => {
                if (e.lengthComputable && this.pendingUploads[uploadGuid]) {
                  this.pendingUploads[uploadGuid].sizes = [
                    e.loaded,
                    e.total,
                    e.loaded / e.total,
                  ];
                  this.calculateUploadProgress();
                }
              },
              false
            );
          }
          return xhr;
        },
        success: (data) => {
          if (success) success(data);
        },
        error: (err) => {
          if (err.statusText === "abort") {
            console.error("Upload canceled by user");
            this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00001, colorOrange: false});
          } else {
            console.error("Error on POST in uploadFile()");
            this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00002, colorOrange: false});
            delete this.pendingUploads[uploadGuid];
          }
          if (error) error();
        },
        complete: () => {
          this.calculateUploadProgress();
          if (done) done();
        },
      });
    },
    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    async uploadFilesv2(files, compress = false) {
      if (compress) {
        const compressedFiles = [];
        for (let file of files) {
          file = await this.compressFile(file, 1).catch((err) => {
            console.error("Error while compressing");
            console.error(err);
            this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00033, colorOrange: false});
          });
          compressedFiles.push(file);
        }
        files = compressedFiles;
      }

      const uploadProcesses = [];
      files.map((file) => {
        uploadProcesses.push(UploadService.upload(file));
      });
      return Promise.all(uploadProcesses);
    },
    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @param {boolean} [offline = false] - Are we in offline mode
     * @param {any} [baseKey = ""] - provide a baseKey for file
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    async uploadFilesv3(
      files,
      compress = false,
      offline = false,
      baseKey = ""
    ) {
      if (compress) {
        const compressedFiles = [];
        for (let file of files) {
          if (!this.isImageType(file)) {
            compressedFiles.push(file);
          } else {
            let blob = await reduceFileSize(file, 500 * 1024, 1920, 1920, 0.9);
            let f = await blobToFile(blob, file);
            compressedFiles.push(f);
          }
        }
        files = compressedFiles;
      }
      let uploadProcesses = [];
      if (offline) {
        uploadProcesses = files.map((file) => {
          return UploadService.uploadOffline(baseKey, file);
        });
      } else {
        uploadProcesses = files.map((file) => {
          return UploadService.uploadOnline(file);
        });
      }
      return Promise.all(uploadProcesses);
    },
    /**
     *
     * @param {File} file -File to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @param {boolean} [offline = false] - Are we in offline mode
     * @param {any} [baseKey = ""] - provide a baseKey for file
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    async uploadFilev3(file, compress = false, offline = false, baseKey = "") {
      if (compress && this.isImageType(file)) {
        let blob = await reduceFileSize(file, 500 * 1024, 1920, 1920, 0.9);
        file = await blobToFile(blob, file);
      }
      if (offline) {
        return await UploadService.uploadOffline(baseKey, file);
      } else {
        return await UploadService.uploadOnline(file, (progressEvent) => {
          this.currentUploadProgress = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        });
      }
    },
    calculateUploadProgress() {
      let sumLoaded = 0,
        sumTotal = 0,
        countDone = 0;
      let count = Object.keys(this.pendingUploads).length;

      for (let upload in this.pendingUploads) {
        sumLoaded += this.pendingUploads[upload].sizes[0];
        sumTotal += this.pendingUploads[upload].sizes[1];
        countDone += this.pendingUploads[upload].sizes[2];
      }

      if (count < 1 || countDone == count) {
        this.currentUploadProgress = 100;
        this.pendingUploads = {};
        return;
      }
      this.currentUploadProgress = Number(
        ((sumLoaded * 100) / sumTotal).toFixed(0)
      );
    },
    cancelPendingUploads() {
      this.$nextTick(() => {
        for (let guid in this.pendingUploads) {
          this.pendingUploads[guid].request.abort();
        }
        this.pendingUploads = {};
        // the modal automatically opens when progress is below 50 so set it higher
        this.currentUploadProgress = 100;
        //Stops the activ loading (Like clicking stop in the browser)
        window.stop();
      });
    },
    isValidFileType(file, acceptedTypes) {
      if (!acceptedTypes) return true;
      let types = _.split(_.replace(acceptedTypes, / /g, ""), ",");

      for (let type of types) {
        if (
          (type === "image/*" && _.startsWith(file.type, "image/")) ||
          (type === "video/*" && _.startsWith(file.type, "video/")) ||
          (type === "audio/*" && _.startsWith(file.type, "audio/"))
        )
          return true;

        if (file.type === type) return true;

        if (_.startsWith(type, ".") && _.endsWith(file.name, type)) return true;
      }
      return false;
    },
    getRegionsList(callback) {
      if (!_.isEmpty(this.regionsList)) {
        callback(this.regionsList);
        return;
      }

      let queryString = `api/Data/Regions`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.regionsList = data;
          callback(this.regionsList);
        },
        error: () => {
          console.error("Error on GET in getRegionsList()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00009, colorOrange: false});
        },
      });
    },
    // Requests the language strings for the selected language from server
    getLanguageStrings(that, success, error) {
      if (that.$options.name && this.langCache[that.$options.name]) {
        that.lang = this.langCache[that.$options.name];
        if (success) success();
        return;
      }
      const langKeys = Object.keys(that.lang);

      UseLang.getTranslationfor(langKeys)
        .then(({ data }) => {
          let dataKeys = Object.keys(data);
          if (dataKeys.length == langKeys.length) that.lang = data;
          else {
            for (let i = 0; i < dataKeys.length; i++) {
              that.lang[dataKeys[i]] = data[dataKeys[i]];
            }
          }
          if (that.$options.name)
            this.langCache[that.$options.name] = that.lang;
          if (success) success();
        })
        .catch((err) => {
          if (err.status === 0 || err.status === 401) return; // Request canceled or unauthorized
          console.error(
            "Language data access failed in getLanguageStrings()",
            err
          );
          this.$emit("openGlobalErrorDialog", {errorText: this.lang.G00003, colorOrange: false});
          if (error) error(err);
        });
    },
    // Requests information about the current user from backend
    getCurrentUserInfo(callback, errorCallback) {
      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/Current",
        success: (data) => {
          this.currentUserInfo = data;
          this.selectedLanguage = data.FrontendLanguageCode;
          this.$emit("currentUserInfoReceived");
          if (callback) callback();
        },
        error: () => {
          console.error("Userdata access failed in getCurrentUserInfo()");
          this.currentUserInfo = null;
          if (errorCallback) errorCallback();
        },
      });
    },
    isAccessAllowed(policy) {
      if (!policy || !this.currentUserInfo || !this.currentUserInfo.Policies)
        return false;

      let idx = this.currentUserInfo.Policies.indexOf(policy);
      if (idx < 0) return false;
      return true;
    },
    // Requests a list of all countries and returns it by calling the callback function
    getCountryList(callback) {
      if (!_.isEmpty(this.countryList)) {
        if (callback) callback(this.countryList);
        return;
      }

      let queryString = `api/Data/Countries`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.countryList = data;
          if (callback) callback(this.countryList);
        },
        error: () => {
          console.error("Error on GET in getCountryList()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00004, colorOrange: false});
        },
      });
    },
    getOccupationalGroupList(callback) {
      if (!_.isEmpty(this.occupationalGroupList)) {
        callback(this.occupationalGroupList);
        return;
      }

      let queryString = `api/Data/OccupationalGroup`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.occupationalGroupList = data;
          callback(this.occupationalGroupList);
        },
        error: () => {
          console.error("Error on GET in getOccupationalGroupList()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00005, colorOrange: false});
        },
      });
    },
    getPasswordPolicyList(callback) {
      if (!_.isEmpty(this.passwordPolicyList)) {
        callback(this.passwordPolicyList);
        return;
      }

      let queryString = `api/Data/PasswordPolicy`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.passwordPolicyList = data;
          callback(this.passwordPolicyList);
        },
        error: () => {
          console.error("Error on GET in getPasswordPolicyList()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00006, colorOrange: false});
        },
      });
    },
    getSettlementStatusList(callback) {
      if (!_.isEmpty(this.settlementStatusList)) {
        callback(this.settlementStatusList);
        return;
      }

      let queryString = `api/Data/SettlementStatusses`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.settlementStatusList = Object.keys(data).map((key) => ({
            SettlementStatusGuid: key,
            SettlementStatusText: data[key],
          }));
          callback(this.settlementStatusList);
        },
        error: () => {
          console.error("Error on GET in getSettlementStatusList()");
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.G00007, colorOrange: false});
        },
      });
    },
    isLargeScreen() {
      return $(window).width() > 1200;
    },
    isMediumScreen() {
      let width = $(window).width();
      return width <= 1200 && width > 1000;
    },
    isSmallScreen() {
      return $(window).width() <= 1000;
    },
    isScreenOrientationLandscape() {
      return $(window).width() > $(window).height() * (13 / 9);
    },
    // Extracts the date in a localized format from an iso timestamp
    getLocalizedDateFromIsoTimestamp(isoTimestamp) {
      return moment(isoTimestamp).format(this.currentDateFormatForMoment);
    },
    // Extracts the date and time in a localized format from an iso timestamp
    getLocalizedDateTimeFromIsoTimestamp(isoTimestamp) {
      return moment(isoTimestamp).format(this.currentDateTimeFormatForMoment);
    },
    // Extracts the date and time in a localized format from an iso timestamp in UTC
    getLocalizedDateTimeFromUtcIsoTimestamp(isoTimestamp) {
      return moment
        .utc(isoTimestamp)
        .local()
        .format(this.currentDateTimeFormatForMoment);
    },
    // source: https://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
    getImageOrientation(image, callback) {
      if (!image) return;

      let reader = new FileReader();

      reader.onload = (event) => {
        let view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        let length = view.byteLength,
          offset = 2;

        while (offset < length) {
          let marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1);
            }
            let little = view.getUint16((offset += 6), false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            let tags = view.getUint16(offset, little);
            offset += 2;

            for (let i = 0; i < tags; i++)
              if (view.getUint16(offset + i * 12, little) == 0x0112)
                return callback(view.getUint16(offset + i * 12 + 8, little));
          } else if ((marker & 0xff00) != 0xff00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(image.slice(0, 64 * 1024));
    },
    isImageType(img) {
      if (!img) return false;
      return _.startsWith(img.type, "image");
    },
    resetImageOrientation(srcImage, srcOrientation, callback) {
      if (srcOrientation === 1) {
        callback(srcImage);
        return;
      }

      let img = new Image();

      img.onload = () => {
        let width = img.width,
          height = img.height,
          canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        let file = this.dataURItoBlob(canvas.toDataURL(srcImage.type));
        file.name = srcImage.name;
        file.lastModifiedDate = new Date();

        // export base64
        callback(file);
      };

      img.src = srcImage.imageUrl;
    },
    //source: https://web.archive.org/web/20160425180542/http://blog.devteaminc.co/posting-a-canvas-image-to-twitter-using-oauth/
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    truncateString(str, maxLength) {
      if (!str || typeof str !== "string") return "";
      return _.truncate(str, {
        length: maxLength,
        separator: " ",
      });
    },
    /**
     * Turns a File Object into a Base64 String
     * @param {File} - A File Object
     * @returns {Promise<Blob>} - The base encoded File
     */
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getMarkupText(html) {
      if (!html || typeof html !== "string") return "";
      let container = document.createElement("DIV");
      container.innerHTML = html;
      return container.textContent || container.innerText || "";
    },
    isLocalizedDateTodayOrBefore(date) {
      let momentDate = moment(date, this.currentDateFormatForMoment);
      return momentDate.isValid() && this.isISODateTodayOrBefore(momentDate);
    },
    isISODateTodayOrBefore(date) {
      if (!date) return false;
      let momentDate = moment(date);
      if (!momentDate.isValid()) return false;
      let today = moment(new Date());
      return momentDate.isSameOrBefore(today, "day");
    },
  },
  watch: {
    selectedLanguage(newLanguage) {
      if (newLanguage) {
        this.langCache = {};
        this.getLanguageStrings(this);
        this.localizeFlatpickrConfig();
        this.countryList = {};
        this.regionsList = [];
        this.occupationalGroupList = {};
      }
    },
  },
  data() {
    return {
      progressInfos: [],
      isSurveyCodeUser: false,
      currentUserInfo: null,
      countryList: {},
      regionsList: [],
      occupationalGroupList: {},
      passwordPolicyList: [],
      settlementStatusList: [],
      selectedLanguage: "",
      spinnerVisible: false,
      tooltipDelay: {
        show: 500,
        hide: 100,
      },
      /**
       * We used to have clickOpens: false,
       * This was to manually call open() ,but it breaks mobile views so we use the default onClick from flatpickr now
       */
      flatpickrDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        defaultDate: [""],
        locale: "en",
      },
      flatpickrIsoDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Z",
        defaultDate: [""],
        locale: "en",
      },
      flatpickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "en",
      },
      flatpickrDatetimeConfig: {
        altInput: true,
        altFormat: "Y-m-d H:i",
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        locale: "en",
      },
      snackbarConfig: {
        content: "", // text of the snackbar
        style: "",
        timeout: 5000,
        htmlAllowed: false,
      },
      pendingUploads: {},
      currentUploadProgress: 100,
      langCache: {},
      lang: {
        G00000: "No results found",
        G00001: "Upload canceled",
        G00002: "Upload failed",
        G00003: "Language data access failed",
        G00004: "Country data request failed",
        G00005: "Occupational group data request failed",
        G00006: "Password policy data request failed",
        G00007: "Invoice status list data request failed",
        G00009: "Region data request failed",
        G00023: "Success",
        G00024: "Error",
      },
    };
  },
});

export default globals;



// WEBPACK FOOTER //
// ./src/globals.js